module.exports = __webpack_public_path__ + "app/img/logo-telegram.d1223b4a.svg";